<ef-loading-container [observables]="[attachment$]"></ef-loading-container>

<iframe
    *ngIf="attachment$ | async as result"
    [src]="(attachment$ | async)?.File | safe: 'resourceUrl'"
    style="width: 80vw; height: 80vh; border: none"
>
</iframe>
